import { z, zCalendarDate } from '@harvestiq/zod';
import { AipIds } from '@harvestiq/constants';

export const submitAgWorksLrpEndorsementPdfMsgSchema = z.object({
  // iiq
  orgId: z.string(),
  aipId: z.nativeEnum(AipIds),
  endorsementId: z.string().uuid(),

  // pdf data
  pdfUrl: z.string().url(),
  insuredSignatureDate: zCalendarDate(),
  agentSignatureDate: zCalendarDate(),
  premiumLineOID: z.number(),
});

export type SubmitAgWorksLrpEndorsementPdfMsg = z.infer<
  typeof submitAgWorksLrpEndorsementPdfMsgSchema
>;
